import { ArbManifest } from "@amzn/arb-tools";
import { LocalizationContextBuilder } from "@amzn/i18n.localization-context";
import { MbmProvider, useLocalizationContext } from "@amzn/react-arb-tools";
import { Locales, useLocale } from "@amzn/xb-hooks";
import React, { ReactNode } from "react";

const localizationContextBuilder = new LocalizationContextBuilder().withDefaultLocale(Locales.ENGLISH.code);

export const LocalizationUpdater = ({ children }: { children: ReactNode }) => {
  const { locale, isLoading } = useLocale();
  const { localizationContext, setLocalizationContext } = useLocalizationContext();

  if (!isLoading && locale?.code && localizationContext?.getLocale() !== locale.code) {
    setLocalizationContext(localizationContextBuilder.withLocale(locale.code).build());
  }

  return <>{children}</>;
};

export const LocalizationProvider = ({
  children,
  arbManifest,
  resolveResourcePack,
}: {
  children: ReactNode;
  arbManifest: ArbManifest;
  resolveResourcePack: (url?: string) => Promise<any>;
}) => {
  const options = {
    arbManifest,
    defaultLocalizationContext: localizationContextBuilder.build(),
    resolveResourcePack,
  };

  return (
    <MbmProvider {...options}>
      <LocalizationUpdater>{children}</LocalizationUpdater>
    </MbmProvider>
  );
};
